import {FC, useEffect, useState} from 'react';
import styled from '@emotion/styled';
// custom
import { getSubText } from '../../common/helpers/CommonUtil';
import {IEvent} from '../../common/state/events/event';
import SimpleSpinner from '../loaders/spinners/SimpleSpinner';

type IEventUserRegisterTableProps = {
    list: IEvent[] | undefined,
    onView: (data : IEvent) => void    
};

const ContainerStyled = styled.section`
    width: 100%;
    min-height: 300px;
    max-height: 600px;
    table {
        width: 100%
    }
`;

const EventUserRegisterTable : FC <IEventUserRegisterTableProps> = ({list, onView}) => {
    // states    
    const [subTitle, setSubTitle] = useState<string>('Please wait...');    

    // lifecycle
    useEffect(()=>{
        if (list && list.length > 0) {            
            setSubTitle('List of current and upcoming events...');
        } else if (list && list.length === 0) {            
            setSubTitle('There are currently no events. Click on + to add an event');
        }
    },[list]);
    // lifecycle methods
    function populateTable(): JSX.Element {
        return <table
        className="relative w-fit table-auto border-2 border-slate-400 rounded text-gray-700 dark:text-gray-300">
        <thead className='text-gray-700 dark:text-gray-700'>
            <tr>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">#</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Title</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Description</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Start Date</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">End Date</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Preview</th>                      
            </tr>
        </thead>
        <tbody>
            {list && list.map((item: IEvent, index: number)=> {
                const startDate = new Date(item.start_date);
                const endDate = new Date(item.end_date);
                return <tr key={index}>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{index+1}</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{item.title}</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{getSubText(item.description, 80)}
                    </td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{startDate.toDateString()}</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{endDate.toDateString()}</td>
                    <td className="border p-2 border-2 border-slate-400 rounded text-center">
                        <div className="inline-flex">
                            <button
                                onClick={()=>onView(item)}
                                className="bg-gray-300 hover:bg-gray-400 text-sm text-gray-800 font-bold py-2 px-4 rounded">
                                View Event
                            </button>                           
                        </div>
                    </td>                  
                </tr> })}
        </tbody>
    </table>;
    }
    return <ContainerStyled
        className="mt-2 relative bg-gray-100 dark:bg-gray-900 rounded-lg 
                     flex flex-col justify-start items-start shadow-lg 
                    p-4 overflow-hidden overflow-scroll">
        <div role="status"></div>        
        <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
            {subTitle}
        </p>
        <SimpleSpinner display={`inline-block`} loading={!list} title={'Loading events...'}/>
        {Boolean(list && list.length > 0) && populateTable()}
    </ContainerStyled>;
};

export default EventUserRegisterTable;